import { render, staticRenderFns } from "./KeyProjectHigh.vue?vue&type=template&id=bbdd230c&scoped=true"
import script from "./KeyProjectHigh.vue?vue&type=script&lang=js"
export * from "./KeyProjectHigh.vue?vue&type=script&lang=js"
import style0 from "./KeyProjectHigh.vue?vue&type=style&index=0&id=bbdd230c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdd230c",
  null
  
)

export default component.exports